export const PREVIEW_MAX_WIDTH_RATIO_TO_CONTAINER = 0.5

export const PREVIEW_MIN_WIDTH = 400

export const QA_NAME_PREVIEW_RESIZE_HANDLE = 'previewResizeHandle'
